<script>
	// Stores 
	import { textSite, mailComercial, linkWhatsappComercial } from '../store.js'; 

	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";
	import PageHeader from "../components/PageHeader.svelte";
	import Forms from "../components/Forms.svelte";
	import Vitrine from '../components/Vitrine.svelte'

	// Code
	let titlePage = 'Agradecemos pelo contato';

	let vitrines = [
		{
			image: 'vitrineDiaDoSindico.jpg', 
			imageMobile: 'vitrineDiaDoSindicoM.jpg', 
			title: 'Promoção Imperdível',
			href: '#'
		}
	];	

	let loading = false;
	function send() {
		loading = true;
	}    

</script>

<Vitrine vitrines={vitrines} showDots={false} vitrineHeight="460px"/>

<PageHeader title={titlePage} buttons=""></PageHeader> 

<div class="container clearfix text-justify mb-50">

	<div class="text-center">
		<p>Faça download dos seguintes documentos:</p>
		<p>
			<a href="/assets/files/Manual_para_Condominios_LGPD.pdf" target="_blank">
				<img src="/assets/images/botDocLGPD.png" alt="" aria-disabled="true" />
			</a>
		</p>
		<p>
			<a href="/assets/files/Guia_de_Orientacao_do_Sindico_Promo.pdf" target="_blank">
				<img src="/assets/images/botDocGuiaSindico.png" alt="" aria-disabled="true" />
			</a>
		</p>

	</div>

	<div class="text-center mt-50 mb-50">
		<p>Em caso de dúvidas, entre em <a href="/contato" use:link>contato</a> conosco, nossa equipe está à disposição para auxiliar.</p>

		<div class="button text-center mt-20">
			<a href="{$linkWhatsappComercial}" target="_blank" use:link replace title="Fale conosco" class="btn btn-secondary bg-whatsapp mb-20">Fale conosco <div class="arrow-animate"><i class="fab fa-whatsapp"></i></div> </a>

			<a href="/administracao-condominios" target="_blank" use:link replace title="Confira nossos diferenciais" class="btn btn-secondary mb-20">Confira nossos diferenciais <div class="arrow-animate"><i class="far fa-arrow-right"></i></div> </a>
		</div>
	</div>

</div>